/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './vaccination-schedule-details.reducer';

export const VaccinationScheduleDetailsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const vaccinationScheduleDetailsEntity = useAppSelector(state => state.vaccinationScheduleDetails.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="vaccinationScheduleDetailsDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.detail.title">VaccinationScheduleDetails</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.id">Id</Translate>
            </span>
          </dt>
          <dd>{vaccinationScheduleDetailsEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.active">Active</Translate>
            </span>
          </dt>
          <dd>{vaccinationScheduleDetailsEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="ageMax">
              <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.ageMax">Age Max</Translate>
            </span>
          </dt>
          <dd>{vaccinationScheduleDetailsEntity.ageMax}</dd>
          <dt>
            <span id="ageMin">
              <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.ageMin">Age Min</Translate>
            </span>
          </dt>
          <dd>{vaccinationScheduleDetailsEntity.ageMin}</dd>
          <dt>
            <span id="country">
              <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.country">Country</Translate>
            </span>
          </dt>
          <dd>{vaccinationScheduleDetailsEntity.country}</dd>
          <dt>
            <span id="dosage">
              <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.dosage">Dosage</Translate>
            </span>
          </dt>
          <dd>{vaccinationScheduleDetailsEntity.dosage}</dd>
          <dt>
            <span id="gender">
              <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.gender">Gender</Translate>
            </span>
          </dt>
          <dd>{vaccinationScheduleDetailsEntity.gender}</dd>
          <dt>
            <span id="periodInDays">
              <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.periodInDays">Period In Days</Translate>
            </span>
          </dt>
          <dd>{vaccinationScheduleDetailsEntity.periodInDays}</dd>
          <dt>
            <span id="risk">
              <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.risk">Risk</Translate>
            </span>
          </dt>
          <dd>{vaccinationScheduleDetailsEntity.risk}</dd>
          <dt>
            <span id="vaccinationTypeCd">
              <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.vaccinationTypeCd">Vaccination Type Cd</Translate>
            </span>
          </dt>
          <dd>{vaccinationScheduleDetailsEntity.vaccinationTypeCd}</dd>
          <dt>
            <span id="forYear">
              <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.forYear">For Year</Translate>
            </span>
          </dt>
          <dd>{vaccinationScheduleDetailsEntity.forYear}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{vaccinationScheduleDetailsEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{vaccinationScheduleDetailsEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{vaccinationScheduleDetailsEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{vaccinationScheduleDetailsEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.schedule">Schedule</Translate>
          </dt>
          <dd>{vaccinationScheduleDetailsEntity.schedule ? vaccinationScheduleDetailsEntity.schedule.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.vaccinationScheduleDetails.vacciantion">Vacciantion</Translate>
          </dt>
          <dd>{vaccinationScheduleDetailsEntity.vacciantion ? vaccinationScheduleDetailsEntity.vacciantion.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/vaccination-schedule-details" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/vaccination-schedule-details/${vaccinationScheduleDetailsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default VaccinationScheduleDetailsDetail;
